import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import PageSkeleton from "../components/PageSkeleton";
import AppLayout from "../pages/common/AppLayout";
import RouteGuard from "./RouteGuard";
import routes from "./routes";

const wrap = (Component) => (
  <Suspense fallback={<PageSkeleton />}>
    <Component />
  </Suspense>
);

const AppRoutes = () => {
  const noLayoutRoutes = routes.filter((r) => r.noLayout);
  const layoutRoutes = routes.filter((r) => !r.noLayout);

  return (
    <Routes>
      {/* Pages without sidebar (login, 403, error pages) */}
      {noLayoutRoutes.map(({ path, element: Component }, i) => (
        <Route key={`pub-${i}`} path={path} element={wrap(Component)} />
      ))}

      {/* All authenticated pages — Sidebar & Header render once here */}
      <Route element={<AppLayout />}>
        {/* RouteGuard checks page-level access for every navigation */}
        <Route element={<RouteGuard />}>
          {layoutRoutes.map(({ path, element: Component }, i) => (
            <Route key={`app-${i}`} path={path} element={wrap(Component)} />
          ))}
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
